export default __webpack_public_path__ + "static/media/bg-05.c6015514.jpg";